const initialState = {
  fetching: false,
  fetched: false,
  all: [],
  formatedData: [],
  list: [],
  detail: [],
  error: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "BROWSE_BY_FETCHING":
      state = { ...state, ...{ fetching: true } };
      break;

    case "SET_FORMAT_DATA":
      state = { ...state, ...{ formatedData: payload } };
      break;
    case "BROWSE_BY_ERROR":
      state = { ...state, ...{ error: payload.error, fetched: true } };
      break;

    case "BROWSE_BY_FETCHED":
      state = { ...state, ...{ all: payload, fetching: false, fetched: true } };
      break;
    case "BROWSE_DATA_FETCHING":
      state = { ...state, ...{ fetching: true } };
      break;
    case "BROWSE_DATA_ERROR":
      state = { ...state, ...{ error: payload.error, fetched: true } };
      break;

    case "BROWSE_DATA_FETCHED":
      state = {
        ...state,
        ...{ list: payload, fetching: false, fetched: true }
      };
      break;
    case "BROWSE_DETAIL_FETCHING":
      state = { ...state, ...{ fetching: true } };
      break;
    case "BROWSE_DETAIL_ERROR":
      state = { ...state, ...{ error: payload.error, fetched: true } };
      break;

    case "BROWSE_DETAIL_FETCHED":
      state = {
        ...state,
        ...{ detail: payload, fetching: false, fetched: true }
      };
      break;
    default:
      break;
  }
  return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/reducers/browseBy.js